module.exports = __webpack_public_path__ + "img/openbadge-type-1.835cba40.png";